module.exports = __webpack_public_path__ + "assets/img/title-c73a6010.png";